// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { HistoryType } from "../../Utils/History/HistoryType.ts";
import { MathUtils } from "../../Utils/MathUtils.js";
import { ErrorInformationStorage } from "../ErrorInformationStorage.js";

export let SpreadPlan = function ()
{
    this.Id;
    this.Name;
    this.itemsByType = new Object();// new Dictionary<int, RevenueSpreadItem>();
    this.itemsBySymbol = new Object();//new Dictionary<string, RevenueSpreadItem>();

    /// <summary>
    /// List of spread settings for each instrument
    /// </summary>

    this.items = new Object();// new Dictionary<string, SpreadItem>();
}

SpreadPlan.prototype.InitBy = function (message, dc)
{
    this.Id = message.Id.toString();
    this.Name = message.Name;
    let listOfTyped = new Array();//new List<RevenueSpreadItem>();
    let copyByType = new Object();//new Dictionary<int, RevenueSpreadItem>();
    let copyBySymbol = new Object();//new Dictionary<string, RevenueSpreadItem>();

    let len = message.SpreadItems.length;

    for (let i = 0; i < len; i++)
    {
        let si = message.SpreadItems[i];
        if (!si.InstrumentId)
            listOfTyped.push(si);
        else
            copyBySymbol[si.InstrumentId] = si;
    }

    //TODO IMPLEMENT
    //listOfTyped.Sort(new TypeHierarchyComparer<RevenueSpreadItem>(dc));

    len = listOfTyped.length;
    for (let i = 0; i < len; i++)
    {
        let si = listOfTyped[i];
        if (si.InstrumentTypeId == -1)
            copyByType[-1] = si;
        else
        {
            let list = new Array();
            dc.FindInstrumentTypes(si.InstrumentTypeId, list);
            let len_j = list.length;
            for (let j = 0; j < len_j; j++)
                copyByType[list[j]] = si;
        }
    }

    this.itemsBySymbol = copyBySymbol;
    this.itemsByType = copyByType;

    this.items = new Object();
    this.ApplyForInstruments(dc.getCachedInstruments());
}

SpreadPlan.prototype.ApplyForInstruments = function (instruments)
{
    let len = instruments.length;
    for (let i = 0; i < len; i++)
        this.ApplyForInstrument(instruments[i]);
}

SpreadPlan.prototype.ApplyForInstrument = function (instrument)
{
    try
    {
        if (this.itemsBySymbol != null)
        {
            let item = this.itemsBySymbol[instrument.Id];
            if (!item) // by symbol
                if (this.itemsByType != null)// by type
                {
                    item = this.itemsByType[instrument.TypeId];
                    if (!item)
                    {
                        item = this.itemsByType[-1];
                        if (!item) // default
                            return;
                    }
                }

            var si = SpreadPlan.CreateSpreadItem(item, instrument);
            this.items[instrument.GetInteriorID()] = si;
        }
        else
            return;
    }
    catch (ex)
    {
        ErrorInformationStorage.GetException(ex);
        //Utils.log(ex);
    }
}

SpreadPlan.prototype.GetItem = function (name)
{
    return this.items[name] || null;
}

SpreadPlan.prototype.IsNotEmptyPlan = function (name)
{
    //if (Object.keys(this.items).length == 0)
    //    return false;

    let item = this.GetItem(name);
    if (item == null)
        return false;

    if (item.SpreadMode != SpreadPlan.NOT_FIXED_SPREADMODE || item.BidShift != 0 || item.AskShift != 0)
        return true;
    else
        return false;
}

/// <summary>
/// Расчёт цен
/// </summary>        
SpreadPlan.prototype.CalcBid = function (bid, ask, ins, round = true)
{
    // No spread rules for this instrument?
    let spreadItem = this.items[ins.GetInteriorID()];
    if (!spreadItem)
        return bid;

    return spreadItem.CalcBid(bid, ask, ins, round);
}
SpreadPlan.prototype.CalcAsk = function (bid, ask, ins, round = true)
{
    // No spread rules for this instrument?
    let spreadItem = this.items[ins.GetInteriorID()];
    if (!spreadItem)
        return ask;

    return spreadItem.CalcAsk(bid, ask, ins, round);
}

SpreadPlan.CreateSpreadItem = function (item, instrument)
{
    let si = new SpreadItem(instrument);
    si.AskShift = item.AskShift;
    si.BidShift = item.BidShift;
    si.Spread = item.Spread;
    si.SpreadCoef = SpreadPlan.getSpreadCoef(instrument, item.SpreadMeasure);
    si.SpreadMode = (item.SpreadMode == SpreadPlan.NOT_FIXED_SPREADMODE &&
        (item.SpreadMeasure == SpreadMeasureMode.SPREAD_IN_BASIC_POINTS || item.SpreadMeasure == SpreadMeasureMode.SPREAD_IN_BASIC_POINTS_POST_EXECUTION)) ? SpreadPlan.DYNAMIC_SPREADMODE : item.SpreadMode;
    si.SpreadMeasure = item.SpreadMeasure;
    return si;
}


SpreadPlan.getSpreadCoef = function (inst, spreadMeasure)
{
    switch (spreadMeasure)
    {
        case SpreadMeasureMode.SPREAD_IN_PIPS:
            return inst.PointSize;

        case SpreadMeasureMode.SPREAD_IN_BASIC_POINTS:
        case SpreadMeasureMode.SPREAD_IN_BASIC_POINTS_POST_EXECUTION:
            return 0.0001;

        case SpreadMeasureMode.SPREAD_IN_CURRENCY:
        case SpreadMeasureMode.SPREAD_IN_CURRENCY_POST_EXECUTION:
        default:
            return 1;
    }
}

SpreadPlan.NOT_FIXED_SPREADMODE = 0;
SpreadPlan.ASK_SPREADMODE = 1;
SpreadPlan.BID_SPREADMODE = 2;
SpreadPlan.BID_ASK_SPREADMODE = 3;
SpreadPlan.LIMEN_SPREADMODE = 4;
SpreadPlan.DYNAMIC_SPREADMODE = 1000; //вымышленный тип под динамический спред в базовых пунктах.       

export let SpreadMeasureMode =
{
    SPREAD_IN_PIPS: 0,
    SPREAD_IN_CURRENCY: 1,
    SPREAD_IN_BASIC_POINTS: 2,
    SPREAD_IN_BASIC_POINTS_POST_EXECUTION: 3,
    SPREAD_IN_CURRENCY_POST_EXECUTION: 4
}

SpreadPlan.prototype.IsNeedLoadHistoryForSpread = function (instrDescr, historyType)
{
    //дополнительные проверки, нужно ли закачивать историю
    let item = this.GetItem(instrDescr);

    if (item.SpreadMode == SpreadPlan.ASK_SPREADMODE && historyType == HistoryType.QUOTE_ASK)
        return false;

    if (item.SpreadMode == SpreadPlan.BID_SPREADMODE && historyType == HistoryType.QUOTE_LEVEL1)
        return false;

    if (item.SpreadMode == SpreadPlan.DYNAMIC_SPREADMODE)
        return false;

    if (item.SpreadMode == SpreadPlan.NOT_FIXED_SPREADMODE)
        return false;

    return true;
}

/// <summary>
/// Настройки спреда, для конкретного инструмента
/// </summary>
export let SpreadItem = function (instrument)
{
    this.TickSize = 0;
    this.SpreadMode;
    this.BidShift;
    this.AskShift;
    this.Spread;
    this.SpreadCoef;
    this.SpreadMeasure;
    this.instrumentName;
    this.SpreadInstrument = null;
    if (instrument !== null)
    {
        this.TickSize = instrument.PointSize;
        this.SpreadInstrument = instrument;
    }


}

SpreadItem.prototype.CalcBid = function (bid, ask, instrument, round = true)
{
    try
    {
        // #32479  (Watchlist) некорректные даные в watchlist при использовании спред
        if (isNaN(bid) && isNaN(ask))
            return Number.NaN;

        if (isNaN(bid) && (this.SpreadMode == SpreadPlan.DYNAMIC_SPREADMODE || this.SpreadMode == SpreadPlan.BID_SPREADMODE || this.SpreadMode == SpreadPlan.NOT_FIXED_SPREADMODE)) //#45307
            return Number.NaN;

        // if (bid == 0 && ask == 0)
        //     return 0;

        let bidSpread;
        let instr = instrument != null ? instrument : null;
        let useVariableTickSize = this.SpreadMeasure === SpreadMeasureMode.SPREAD_IN_PIPS && instr != null && instr.VariableTickList.length > 1;

        switch (this.SpreadMode)
        {
            case SpreadPlan.ASK_SPREADMODE:
                if (useVariableTickSize)
                    bidSpread = !isNaN(ask) ? instr.CalculatePrice(ask, (this.AskShift - this.Spread)) : bid;
                else
                    bidSpread = !isNaN(ask) ? (ask + this.AskShift * this.SpreadCoef) - this.Spread * this.SpreadCoef : bid;
                break;

            case SpreadPlan.BID_ASK_SPREADMODE:
                if (isNaN(ask))
                    ask = bid;
                if (isNaN(bid))
                    bid = ask;
                if (useVariableTickSize)
                {
                    let askWithAskShift = instr.CalculatePrice(ask, this.AskShift);
                    let bidWithBidShift = instr.CalculatePrice(bid, this.BidShift);
                    bidSpread = instr.CalculatePrice(((askWithAskShift + bidWithBidShift) / 2), (-this.Spread / 2)); //Spread здесь всегда четный
                }
                else
                    bidSpread = ((ask + this.AskShift * this.SpreadCoef + bid + this.BidShift * this.SpreadCoef) - this.Spread * this.SpreadCoef) / 2;
                break;

            case SpreadPlan.LIMEN_SPREADMODE:
                if (isNaN(ask))
                    ask = bid;
                if (isNaN(bid))
                    bid = ask;

                let newAsk, newBid, delta, resBid;

                if (useVariableTickSize)
                {
                    newAsk = instr.CalculatePrice(ask, this.AskShift);
                    newBid = instr.CalculatePrice(bid, this.BidShift);
                    let delta_ticks = instr.CalculateTicks(newBid, newAsk - newBid); //считаем в тиках

                    if (delta_ticks < this.Spread)
                        resBid = instr.CalculatePrice(newBid, ((delta_ticks - this.Spread) / 2));
                    else
                        resBid = newBid;
                }
                else
                {
                    newAsk = ask + this.AskShift * this.SpreadCoef;
                    newBid = bid + this.BidShift * this.SpreadCoef;
                    delta = (newAsk - newBid) - this.Spread * this.SpreadCoef;

                    resBid = newBid;
                    // if (delta < 0) neative
                    resBid = newBid + delta / 2;
                }
                bidSpread = resBid;
                break;

            case SpreadPlan.DYNAMIC_SPREADMODE: //вымышленный тип под инструмент в пунктах
                if (useVariableTickSize)
                {
                    let price = instr.CalculatePrice(bid, (bid * this.BidShift));
                    bidSpread = !isNaN(bid) ? MathUtils.RoundToIncrement(price, instr.FindVariableTick(price).PointSize) : 0;
                }
                else
                {
                    let price = bid - bid * this.BidShift * this.SpreadCoef;
                    bidSpread = !isNaN(bid) ? MathUtils.RoundToIncrement(price, instr != null ? instr.FindVariableTick(price).PointSize : TickSize) : 0;
                }
                break;

            case SpreadPlan.BID_SPREADMODE:
            case SpreadPlan.NOT_FIXED_SPREADMODE:
            default:
                if (useVariableTickSize)
                    bidSpread = !isNaN(bid) ? instr.CalculatePrice(bid, this.BidShift) : bid;
                else
                    bidSpread = !isNaN(bid) ? bid + this.BidShift * this.SpreadCoef : bid;
                break;
        }

        // negative
        // if (bidSpread < 0)
        //     return Number.NaN;
        // else
        return instr != null && round ? instr.RoundPriceToNearestPointSize(bidSpread) : bidSpread;
    }
    catch (ex) 
    {
        ErrorInformationStorage.GetException(ex);
    }
    return bid;
}

SpreadItem.prototype.CalcAsk = function (bid, ask, instrument, round = true)
{
    try
    {
        // #32479  (Watchlist) некорректные даные в watchlist при использовании спред
        if (isNaN(bid) && isNaN(ask))
            return Number.NaN;

        if (isNaN(ask) && (this.SpreadMode == SpreadPlan.DYNAMIC_SPREADMODE || this.SpreadMode == SpreadPlan.ASK_SPREADMODE || this.SpreadMode == SpreadPlan.NOT_FIXED_SPREADMODE)) //#45307
            return Number.NaN;

        // if (bid == 0 && ask == 0)
        // return 0;

        let askSpread;
        let instr = instrument != null ? instrument : null;
        let useVariableTickSize = this.SpreadMeasure == SpreadMeasureMode.SPREAD_IN_PIPS && instr != null && instr.VariableTickList.length > 1;

        switch (this.SpreadMode)
        {
            case SpreadPlan.BID_SPREADMODE:
                if (useVariableTickSize)
                    askSpread = !isNaN(bid) ? instr.CalculatePrice(bid, (this.BidShift + this.Spread)) : ask;
                else
                    askSpread = !isNaN(bid) ? (bid + this.BidShift * this.SpreadCoef) + this.Spread * this.SpreadCoef : ask;
                break;

            case SpreadPlan.BID_ASK_SPREADMODE:
                if (isNaN(bid))
                    bid = ask;
                if (isNaN(ask))
                    ask = bid;

                if (useVariableTickSize)
                {
                    let askWithAskShift = instr.CalculatePrice(ask, this.AskShift);
                    let bidWithBidShift = instr.CalculatePrice(bid, this.BidShift);
                    askSpread = (instr.CalculatePrice(((askWithAskShift + bidWithBidShift) / 2), (this.Spread / 2))); //Spread здесь всегда четный
                }
                else
                    askSpread = ((ask + this.AskShift * this.SpreadCoef + bid + this.BidShift * this.SpreadCoef) + this.Spread * this.SpreadCoef) / 2;
                break;

            case SpreadPlan.LIMEN_SPREADMODE:

                if (isNaN(bid))
                    bid = ask;
                if (isNaN(ask))
                    ask = bid;

                let newAsk, newBid, delta, resAsk;
                if (useVariableTickSize)
                {
                    newAsk = instr.CalculatePrice(ask, this.AskShift);
                    newBid = instr.CalculatePrice(bid, this.BidShift);
                    let delta_ticks = instr.CalculateTicks(newBid, newAsk - newBid); //считаем в тиках

                    if (delta_ticks < this.Spread)
                        resAsk = instr.CalculatePrice(newAsk, (-(delta_ticks - this.Spread) / 2));
                    else
                        resAsk = newAsk;
                }
                else
                {
                    newAsk = ask + this.AskShift * this.SpreadCoef;
                    newBid = bid + this.BidShift * this.SpreadCoef;
                    delta = (newAsk - newBid) - this.Spread * this.SpreadCoef;

                    resAsk = newAsk;
                    // if (delta < 0) negative
                    resAsk = newAsk - delta / 2;
                }
                askSpread = resAsk;
                break;

            case SpreadPlan.DYNAMIC_SPREADMODE: //вымышленный тип под инструмент в пунктах
                if (useVariableTickSize)
                {
                    let price = instr.CalculatePrice(ask, (ask * this.AskShift));
                    askSpread = !isNaN(ask) ? MathUtils.RoundToIncrement(price, instr.FindVariableTick(price).PointSize) : 0;
                }
                else
                {
                    let price = ask + ask * this.AskShift * this.SpreadCoef;
                    askSpread = !isNaN(ask) ? MathUtils.RoundToIncrement(price, instr != null ? instr.FindVariableTick(price).PointSize : TickSize) : 0;
                }
                break;

            case SpreadPlan.ASK_SPREADMODE:
            case SpreadPlan.NOT_FIXED_SPREADMODE:
            default:
                if (useVariableTickSize)
                    askSpread = !isNaN(ask) ? instr.CalculatePrice(ask, this.AskShift) : ask;
                else
                    askSpread = !isNaN(ask) ? (ask + this.AskShift * this.SpreadCoef) : ask;
                break;
        }

        //negative
        // if (askSpread < 0)
        //     return Number.NaN;
        // else
        return instr != null && round ? instr.RoundPriceToNearestPointSize(askSpread) : askSpread;
    }
    catch (ex) 
    {
        ErrorInformationStorage.GetException(ex);
    }
    return ask;
}
